import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function FeatureGrid() {
  const featuredArticles = articles.filter((a) => a.isFeatured).slice(0, 3);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-start gap-4 mb-10 md:mb-14">
          <div className="flex-1">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-black text-foreground-950 leading-tight">
              热门追踪
            </h2>
            <p className="font-heading text-lg md:text-xl italic text-foreground-400 mt-1 font-light">
              本周最火黑料追踪
            </p>
          </div>
          <div className="lg:w-64">
            <p className="text-sm text-foreground-500 leading-relaxed">
              精选本周讨论度最高的网红黑料事件，多角度还原事件真相，理性吃瓜不站队。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {featuredArticles.map((article, index) => (
            <div key={article.id} className={index === 0 ? 'lg:col-span-1 lg:row-span-1' : ''}>
              <ArticleCard
                {...article}
                variant={index === 0 ? 'featured' : 'default'}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}